import React, { useState, useEffect, useRef } from 'react';
import { Select, Input, Button } from 'antd';
import TaskObject from '@atlaskit/object/task';
import StoryObject from '@atlaskit/object/story';
import BugObject from '@atlaskit/object/bug';
import SubtaskObject from '@atlaskit/object/subtask';

const { Option } = Select;

const InlineCreateRow = ({
  placeholder,
  value,
  onChange,
  onCreate,
  onCancel,
  buttonText,
  indent = 0,
  createLevel = 'task',
  handleAddTask,
}) => {
  const [Title, setTitle] = useState('');
  const [selectedType, setSelectedType] = useState('Task');
  const [selectedTypeId, setSelectedTypeId] = useState(1);

  // Type to ID mapping
  const TYPE_TO_ID = {
    Task: 1,
    Story: 2,
    Bug: 3,
  };

  const wrapperRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target) &&
        !event.target.closest('.ant-select-dropdown')
      ) {
        onCancel();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onCancel]);

  useEffect(() => {
    if (createLevel === 'subtask') {
      setSelectedType('Subtask');
      setSelectedTypeId(4);
    } else {
      setSelectedType('Task');
      setSelectedTypeId(1);
    }
  }, [createLevel]);


  useEffect(() => {
    setSelectedTypeId(TYPE_TO_ID[selectedType] || 1);
  }, [selectedType]);

  const handleAdd = () => {

    if (!Title.trim()) return;

    const payload = {
      issue_title: Title,
      issue_status: 'TO DO',
      issue_type_id: selectedTypeId,
      issue_type: selectedType,
    };

    if (typeof onCreate === 'function') {
      onCreate(payload);
    }

    setTitle('');
  };

  return (
    <div
      ref={wrapperRef}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        marginLeft: indent,
        maxWidth: 900,
        width: '100%',
      }}
    >
      <Select
        value={selectedType}
        onChange={(value) => setSelectedType(value)}
        style={{ width: 100 }}
        getPopupContainer={(trigger) => trigger.parentElement}
      >
        {createLevel === 'issue' && (
          <>
            <Option value="Task">
              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <TaskObject width={35} stroke="#0052CC" />
                <span>Task</span>
              </div>
            </Option>

            <Option value="Bug">
              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <BugObject width={35} stroke="#172B4D" />
                <span>Bug</span>
              </div>
            </Option>

            <Option value="Story">
              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <StoryObject width={35} stroke="#36B37E" />
                <span>Story</span>
              </div>
            </Option>
          </>
        )}

        {createLevel === 'subtask' && (
          <Option value="Subtask">
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <SubtaskObject width={35} stroke="#6554C0" />
              <span>Subtask</span>
            </div>
          </Option>
        )}
      </Select>

      <input
        autoFocus
        value={Title}
        placeholder={placeholder}
        onChange={(e) => {
          setTitle(e.target.value);
          if (typeof onChange === 'function') onChange(e.target.value);
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') handleAdd();
          if (e.key === 'Escape') onCancel();
        }}
        style={{
          width: 500,
          minWidth: 400,
          height: 32,
          padding: '0 10px',
          border: '1px solid #DFE1E6',
          borderRadius: 4,
        }}
      />

      <Button
        style={{ backgroundColor: '#722ed1', color: 'white' }}
        onClick={handleAdd}
      >
        Add
      </Button>

      <Button
        onClick={onCancel}
        style={{
          height: 32,
          border: 'none',
          background: 'transparent',
          cursor: 'pointer',
          color: '#42526E',
        }}
      >
        Cancel
      </Button>
    </div>
  );
};

export default InlineCreateRow;
